import { SET_PLANS } from "./types";
import { apiCallV2 } from "../../../utils/api";

export const LoadPlans = () => async (dispatch) => {
    dispatch({ type: SET_PLANS, details: [] });
};

export const CreatePurchase = () => async () => ({ status: 200 });

export const CreatePurchaseDirect = () => async () => ({ status: 200 });

export const CreatePurchaseUsingCoupon = () => async () => ({ status: 200 });

export const CreatePurchaseWhilePromo = () => async () => ({ status: 200 });

export const GetPlanSaleInfo = (id) => async (dispatch) => {
    const res = await apiCallV2("GET", "get-plan-sale-info", "", localStorage.getItem("access-token"), {
        saleID: id,
    });

    if (res?.data?.status == 200 && res?.data?.data?.sale?.id) {
        return {
            success: res?.data?.data?.sale?.id ? true : false,
            data: { ...res?.data?.data },
        };
    } else {
        return { success: false };
    }
};
